import React, { useState } from "react"

import { StaticImage } from "gatsby-plugin-image"

import pyramid from '../images/pyramid.gif'

import Ticker from "../components/ticker"

import { Link } from "gatsby"

import Layout from '../components/layout'

// markup
const IndexPage = () => {

  const hiero = 'hiero'
  const english = 'english'

  const [language, setLanguage] = useState(hiero)

  const changeLanguage = (language, divPosition) => {
    setLanguage(language)

    // remove active class from where it's currently set and set it to the selected class name matching div position (left or right)
    document.getElementsByClassName('active')[0].classList.remove('active')
    document.getElementsByClassName(divPosition)[0].classList.add('active')
  }

  return (
    <Layout>
      <main className="section">
        <Ticker />
        <div className="columns is-vcentered mt-4">
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} className="column is-10">
            <StaticImage src='../images/title.png' alt='Isah The Prince' />
            <img src={pyramid} alt='slowly spinning gif of a golden pyramid' className="pyramid mt-4" />
          </div>
          <div className="column is-2 links">
              <div className="switch mb-4">
                <div className="active left" 
                  onClick={ () => changeLanguage(hiero, 'left') } 
                  role="button" 
                  onKeyDown={(e) => { e.key === "Enter" && changeLanguage(hiero, 'left') } }
                  tabIndex={0}
                >
                  <p className="hiero is-size-1">abc</p>
                </div>
                <div className="right" 
                  onClick={ () => changeLanguage(english, 'right') } 
                  role="button"
                  onKeyDown={(e) => { e.key === "Enter" && changeLanguage(hiero, 'left') } }
                  tabIndex={0}
                >
                  <p className="english is-size-4">abc</p>
                </div>
              </div>
              <Link to="/listen">
                {
                  language === hiero ? 
                    <StaticImage src={`../images/hieroglyphics/listen.png`} alt={`listen written in hieroglyphics`} className="my-4" />
                    :
                    <span className="english is-size-2">listen</span>
                }
              </Link>
              <Link to="/the-black-pill">
                {
                  language === hiero ? 
                    <StaticImage src={`../images/hieroglyphics/read.png`} alt={`read written in hieroglyphics`} className="my-4" />
                    :
                    <span className="english is-size-2">read</span>
                }
              </Link>
              <a href='https://mailchi.mp/22a5cb1cad06/new-black-elite' target="_blank" rel="noopener noreferrer">
                {
                  language === hiero ? 
                    <StaticImage src={`../images/hieroglyphics/subscribe.png`} alt={`subscribe written in hieroglyphics`} className="my-4" />
                    :
                    <span className="english is-size-2">subscribe</span>
                }
              </a>
              <Link to="/merch">
                {
                  language === hiero ? 
                    <StaticImage src={`../images/hieroglyphics/elevate.png`} alt={`elevate written in hieroglyphics`} className="my-4" />
                    :
                    <span className="english is-size-2">merch</span>
                }
              </Link>
              <Link to="/about">
                {
                  language === hiero ? 
                    <StaticImage src={`../images/hieroglyphics/about.png`} alt={`about written in hieroglyphics`} className="my-4" />
                    :
                    <span className="english is-size-2">about</span>
                }
              </Link>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default IndexPage
